import { Link, Navigate } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { ChevronLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function GoogleAuthPage({ mode = "in" }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 p-4">
      <Logo />
      {mode === "in"
        ? <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
        : <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />}
      <Link to="/entrar" data-testid="back-to-email-login" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Entrar com e-mail e senha
      </Link>
    </div>
  );
}
